import { Component } from '@angular/core'

@Component({
	selector: 'app-system-register-page',
	templateUrl: './register.component.html',
})
export class RegisterPage {}
